export default __webpack_public_path__ + "static/media/account.6f907c32.svg";